import apiService from './api';

export interface SocialBookmarkingModuleData {
  project_context: {
    brand: string;
    description: string;
    tone: string;
    audience: string;
    website_url: string;
    keywords: string[];
    products: string[];
    services: string[];
  };
  recommended_tags: string[];
  eligible_pages: {
    page_id: string;
    url: string;
    type: string;
    title: string | null;
  }[];
  platforms: {
    platform_name: string;
    platform_url: string;
    da_score: number;
  }[];
  is_new_website?: boolean;
}

export interface BookmarkGenerationRequest {
  page_ids: string[];
}

export interface BookmarkGenerationResponse {
  generation_id: string;
  status: string;
}

export interface BookmarkItem {
  id: string;
  target_url: string;
  status: string;
  title?: string;
  description?: string;
  tags?: string[];
  image_url?: string | null;
  published_platforms?: string[];
  is_user_modified: boolean;
  generated_at?: string;
}

export interface BookmarkEditRequest {
  title?: string;
  description?: string;
  tags?: string[];
  published_platforms?: string[];
}



export async function getModuleData(): Promise<SocialBookmarkingModuleData> {
  // apiService.request returns the raw JSON body directly (no wrapper)
  const res = await apiService.request<SocialBookmarkingModuleData>(
    '/social-bookmarking/module-data',
    { method: 'GET' }
  );
  return res;
}

export async function generateBookmarks(payload: BookmarkGenerationRequest): Promise<BookmarkGenerationResponse> {
  const res = await apiService.request<BookmarkGenerationResponse>(
    '/social-bookmarking/generate-content',
    {
      method: 'POST',
      body: JSON.stringify(payload),
    }
  );
  return res;
}

export async function getGeneratedBookmarks(generationId: string): Promise<BookmarkItem[]> {
  const res = await apiService.request<BookmarkItem[]>(
    `/social-bookmarking/generated/${encodeURIComponent(generationId)}`,
    { method: 'GET' }
  );
  return res;
}

export async function getAllBookmarks(): Promise<BookmarkItem[]> {
  const res = await apiService.request<BookmarkItem[]>(
    '/social-bookmarking/bookmarks',
    { method: 'GET' }
  );
  return res;
}

export async function updateBookmark(bookmarkId: string, payload: BookmarkEditRequest): Promise<BookmarkItem> {
  const res = await apiService.request<BookmarkItem>(
    `/social-bookmarking/bookmarks/${encodeURIComponent(bookmarkId)}`,
    {
      method: 'PUT',
      body: JSON.stringify(payload),
    }
  );
  return res;
}

